import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion"; // Import Framer Motion
import "../styles/testimonials.css"; // External CSS

const testimonials = [
  { id: 1, feedback: "Nextcastle Energy Limited delivered exceptional pipeline construction services. Their attention to detail and commitment to safety were impressive." },
  { id: 2, feedback: "Reliable and professional! Their engineering solutions optimized our offshore operations, reducing downtime significantly." },
  { id: 3, feedback: "Working with Nextcastle Energy was a seamless experience. Their procurement services ensured we had top-quality equipment at competitive prices." },
  { id: 4, feedback: "Their corrosion contracting services extended the lifespan of our offshore equipment. Highly recommended!" },
  { id: 5, feedback: "Nextcastle Energy's procurement solutions saved us time and money. Their efficiency is unmatched." },
  { id: 6, feedback: "Excellent customer service and technical expertise. They exceeded our expectations on every project." }
];

const Testimonials = () => {
  const [visibleTestimonials, setVisibleTestimonials] = useState([]);
  const [index, setIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(3); // Default for desktop

  // Function to update visible testimonials based on screen size
  const updateVisibleTestimonials = () => {
    let newItemsToShow = 3; // Default for desktop

    if (window.innerWidth <= 768) {
      newItemsToShow = 2; // Tablet
    }
    if (window.innerWidth <= 480) {
      newItemsToShow = 1; // Mobile
    }

    setItemsToShow(newItemsToShow);
    setVisibleTestimonials(testimonials.slice(index, index + newItemsToShow));
  };

  // Auto-change testimonials every 5 seconds
  useEffect(() => {
    updateVisibleTestimonials();
    const interval = setInterval(() => {
      setIndex((prevIndex) =>
        prevIndex + itemsToShow >= testimonials.length ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [index, itemsToShow]);

  // Update visible testimonials on window resize
  useEffect(() => {
    const handleResize = () => {
      updateVisibleTestimonials();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="testimonials-container">
      <h2 className="testimonials-title">What Our Clients Say</h2>
      <div className="testimonials-grid">
        <AnimatePresence>
          {visibleTestimonials.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <p className="testimonial-feedback">"{testimonial.feedback}"</p>
              <p className="testimonial-client">— A Happy Client</p>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Testimonials;
